import { Button } from '@mui/material'
import React, { useState } from 'react'
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import EditDialog from '../../../Modals/EditColorDialog';
import ConfirmDialog from '../../../Modals/ConfirmDialog';
import { useDeleteColorMutation, useUpdateColorMutation } from '../../../../features/fullApi';
import { Store } from 'react-notifications-component';


const Color = (color) => {

    const [open, setOpen] = useState(false)
    const [openEdit, setOpenEdit] = useState(false)
    const user = JSON.parse(localStorage.getItem('user'))

    const openModalEditItem = ((color) => {
        setOpenEdit(true)
      })
  
      const [updateColor] = useUpdateColorMutation()
      const [deleteColor] = useDeleteColorMutation()
    
      const message = "Are you sure you want to delete this color ?";
    
      const openDeleteModal = (() => {
        setOpen(true)
      })
    
      const handleUpdateColor = ((color) => {
        setOpenEdit(false)
        updateColor({_id: color.id._id, colorName: color.colorName}, { 
          headers: {
            'Token': `Bearer ${user?.accessToken}`
          }
        }).then(
        )
      })
    
    
      const handleDelete = (async (colorId) => {
        deleteColor({id: colorId}).then(
        )
        setOpen(false)
      })

  return (
    <>
    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
    {user?.isAdmin && (
        <div style={{display: 'flex', justifyContent: 'center'}}>
            <Button aria-label="Edit Item" onClick={() => openModalEditItem(color.color._id)}>
              <EditIcon style={{color: 'orange'}}/>
            </Button>
            <Button aria-label="Delete product" onClick={() => openDeleteModal(color.color._id)} size="small">
            <DeleteIcon style={{color: 'red'}}/>
            </Button>
        </div>
    )}
    </div>
    <EditDialog openEdit={openEdit} handleUpdateColor={handleUpdateColor} setOpenEdit={setOpenEdit} item={color.color}>         
    </EditDialog>
    <ConfirmDialog open={open} handleDelete={handleDelete} setOpen={setOpen} item={color.color} message={message}></ConfirmDialog>
  </>
  )
}

export default Color